/** Original KLOTHIQ copy. No third-party quotations or attributed endorsements. */
export const GREETING_LIBRARY = [
  ['Thank you for making us part of your everyday style.', 'Make ordinary days your signature.'],
  ['Your next favourite look has found its way home.', 'Wear what makes you feel like yourself.'],
  ['We are glad this piece gets to be part of your story.', 'Your story deserves its own style.'],
  [
    'Thank you for choosing a little something uncommon.',
    'A little different can feel just right.',
  ],
  ['Here is to good days and even better outfits.', 'Let confidence be your finishing touch.'],
  ['We hope your new favourite goes everywhere with you.', 'Great style belongs in real life.'],
  [
    'Your support gives every detail a little more meaning.',
    'Small details make a lasting impression.',
  ],
  ['Thank you for bringing your individuality to KLOTHIQ.', 'There is only one way to be you.'],
  [
    'May this piece bring a fresh spark to your day.',
    'Start with comfort. Finish with confidence.',
  ],
  [
    'We packed this order with gratitude and good wishes.',
    'Carry a little good energy everywhere.',
  ],
  [
    'Thank you for letting us dress a chapter of your life.',
    'Every chapter deserves a fresh perspective.',
  ],
  [
    'We hope opening this feels like a small celebration.',
    'Find something worth celebrating every day.',
  ],
  ['Your style is the reason we keep creating.', 'Personal style begins with a personal choice.'],
  ['Here is a new piece for the moments ahead.', 'Dress for the memories you want to make.'],
  ['Thank you for choosing us for your next look.', 'Own your look. Enjoy your day.'],
  ['May your new outfit feel as good as it looks.', 'Comfort gives confidence room to grow.'],
  ['We are happy to send a little KLOTHIQ your way.', 'Bring your own character to every room.'],
  ['Your order is a reminder of why we love this work.', 'Thoughtful choices leave a quiet mark.'],
  [
    'Thank you for choosing a style that speaks to you.',
    'Your favourite look needs no explanation.',
  ],
  ['Here is to wearing your mood with confidence.', 'Let your individuality do the talking.'],
  [
    'We hope this becomes the piece you reach for first.',
    'The best favourites feel effortlessly yours.',
  ],
  ['Thank you for making space for us in your wardrobe.', 'Keep room for the things you love.'],
  [
    'May this order add something bright to your routine.',
    'Everyday moments deserve a little colour.',
  ],
  ['We are grateful to be part of your personal style.', 'Stand comfortably in your own identity.'],
  [
    'Your new look is ready for wherever life takes you.',
    'Take your own style along for the ride.',
  ],
  ['Thank you for choosing details that feel like you.', 'Authenticity always fits.'],
  [
    'We hope this piece brings a smile when you wear it.',
    'Good style should feel like good company.',
  ],
  [
    'Here is a little refresh for the days ahead.',
    'A fresh outlook can start with a small choice.',
  ],
  [
    'Thank you for helping our story move forward.',
    'Every thoughtful choice becomes part of something.',
  ],
  [
    'May you make wonderful memories in your new favourite.',
    'The outfit is yours. The memories are too.',
  ],
  ['We hope your new piece feels right from the start.', 'Choose what feels natural to you.'],
  ['Thank you for making KLOTHIQ part of your plans.', 'Show up as yourself, wherever you go.'],
  ['A fresh look and our warmest thanks are inside.', 'Wear your day with a little more joy.'],
  [
    'We are excited for you to make this look your own.',
    'Style comes alive when you wear it your way.',
  ],
  ['Thank you for supporting the care behind each order.', 'Care is a detail you can carry.'],
  [
    'May this piece bring confidence to your next outing.',
    'A confident step starts with feeling at ease.',
  ],
  [
    'We hope this is the beginning of many favourite looks.',
    'Build a wardrobe that reflects your life.',
  ],
  [
    'Thank you for choosing us, one thoughtful piece at a time.',
    'Good style grows through personal choices.',
  ],
  ['Here is to new combinations and familiar comfort.', 'Make room for a fresh kind of familiar.'],
  ['Your individuality is always welcome at KLOTHIQ.', 'Belong without blending in.'],
  ['Thank you for finding something special with us.', 'Special is what feels right to you.'],
  ['We hope your new look makes getting ready a joy.', 'Start your day with something you love.'],
  ['A little wardrobe happiness is on its way to you.', 'Wear a good mood when you can.'],
  [
    'Thank you for letting our brand become part of your day.',
    'Quiet confidence can speak volumes.',
  ],
  ['May your new favourite be there for the best moments.', 'Live the moment. Love the details.'],
  [
    'We hope this piece earns a place in your favourites.',
    'The best style is the one you return to.',
  ],
  [
    'Thank you for choosing your own kind of uncommon.',
    'Being yourself is always a distinctive choice.',
  ],
  ['Here is something new for your one-of-a-kind journey.', 'Follow your path in your own style.'],
  [
    'Your order means a great deal to our small brand.',
    'Meaning often lives in the little things.',
  ],
  ['We hope you feel a little more ready for anything.', 'Confidence looks different on everyone.'],
  [
    'Thank you for trusting us with a piece of your look.',
    'Let your choices reflect your character.',
  ],
  [
    'May this become part of your everyday adventures.',
    'Adventure can begin on an ordinary morning.',
  ],
  [
    'We are grateful your next style story includes us.',
    'A good look is a beginning, not a limit.',
  ],
  ['Thank you for choosing comfort with a little character.', 'Feel at home in what you wear.'],
  ['Here is to outfits that make the day feel lighter.', 'Ease has a style of its own.'],
  ['We hope this order feels like a treat just for you.', 'Leave a little space for your own joy.'],
  [
    'Thank you for bringing our pieces into your world.',
    'Make your everyday world a little more yours.',
  ],
  ['May this look go with plenty of happy plans.', 'Make plans. Make memories. Make it yours.'],
  [
    'Your style choices help our brand keep moving.',
    'Individual choices create a colourful world.',
  ],
  ['We hope your new favourite fits your kind of day.', 'Wear what lets you enjoy the moment.'],
  [
    'Thank you for choosing a look with your own personality.',
    'Character is the best thing you can wear.',
  ],
  [
    'Here is a fresh detail for a fresh perspective.',
    'A different detail can change the whole look.',
  ],
  ['We hope this brings some extra confidence to your routine.', 'Let comfort set the pace.'],
  [
    'Thank you for making our work part of your everyday.',
    'Good design belongs in everyday moments.',
  ],
  ['May your next outing come with a favourite new look.', 'Give your day a personal touch.'],
  ['Your order is appreciated more than this card can say.', 'Gratitude is always in style.'],
  [
    'We hope you enjoy every detail of your new piece.',
    'Take pleasure in the details that matter.',
  ],
  ['Thank you for giving this look your own meaning.', 'The wearer makes the style.'],
  ['Here is to comfortable days and confident entrances.', 'Arrive as you are, with confidence.'],
  ['We are delighted to be part of your next outfit.', 'Bring a little intention to the everyday.'],
  ['May this piece follow you into plenty of good memories.', 'Wear the piece. Keep the memory.'],
  ['Thank you for making a personal choice with KLOTHIQ.', 'Your taste is part of your signature.'],
  [
    'We hope this order makes today feel a little special.',
    'An ordinary day can hold an uncommon moment.',
  ],
  [
    'Here is something to enjoy, style and make your own.',
    'Creativity begins with making it personal.',
  ],
  [
    'Your support helps us keep an eye on every detail.',
    'Purpose gives the smallest details meaning.',
  ],
  ['Thank you for choosing a piece for your real life.', 'Wear it for the life you love living.'],
  [
    'We hope you find your own favourite way to wear this.',
    'There is more than one way to look like you.',
  ],
  [
    'May this new look bring a little lift to your day.',
    'A little confidence can change your stride.',
  ],
  [
    'Thank you for being part of the KLOTHIQ journey.',
    'The journey feels better with good company.',
  ],
  ['Here is to fresh favourites and familiar smiles.', 'Keep the comfort. Add your character.'],
  [
    'We hope this feels like a thoughtful addition to your style.',
    'Choose fewer explanations and more self-expression.',
  ],
  [
    'Your order brings another personal story to our brand.',
    'Every wardrobe tells a different story.',
  ],
  [
    'Thank you for finding your next favourite here.',
    'Great favourites are discovered, then lived in.',
  ],
  [
    'May this piece be part of days you remember fondly.',
    'Some of the best moments are unplanned.',
  ],
  ['We hope your new look feels unmistakably yours.', 'Your own way is a good place to start.'],
  [
    'Thank you for choosing a little confidence for your wardrobe.',
    'Style is a feeling you make visible.',
  ],
  [
    'Here is a new detail for your everyday expression.',
    'Express yourself in the details you choose.',
  ],
  [
    'We are grateful for the chance to be part of your look.',
    'Good things begin with thoughtful choices.',
  ],
  [
    'May this order feel like a warm welcome to KLOTHIQ.',
    'Find your people. Keep your individuality.',
  ],
  ['Thank you for taking our style into your own world.', 'Make every look a reflection of you.'],
  [
    'We hope this piece brings plenty of easy, happy wears.',
    'The best days leave room to be yourself.',
  ],
  [
    'Here is to the confidence of knowing what you like.',
    'Your preferences are part of your personality.',
  ],
  [
    'Your support makes the next step of our story possible.',
    'Progress is built one meaningful step at a time.',
  ],
  [
    'Thank you for choosing a look that feels personal.',
    'Personal style is a conversation with yourself.',
  ],
  [
    'May this become a trusted favourite in your collection.',
    'Keep what feels right. Wear it well.',
  ],
  [
    'We hope you enjoy putting your own spin on this piece.',
    'Give a familiar look an uncommon point of view.',
  ],
  [
    'Thank you for making KLOTHIQ part of something memorable.',
    'Wear your moments, not just your clothes.',
  ],
  [
    'Here is a fresh favourite, sent with our sincere thanks.',
    'Simple choices can carry a lot of character.',
  ],
  [
    'We hope your next great day begins in something you love.',
    'Feel good in your own kind of style.',
  ],
  [
    'Thank you for choosing us and for being wonderfully you.',
    'Craft your look. Keep your individuality.',
  ],
] as const;

export interface GreetingCard {
  id: string;
  number: string;
  customerName: string;
  message: string;
  quote: string;
}

export function buildGreetingCards(
  sales: readonly { id: string; number: string; customerName: string | null }[],
): GreetingCard[] {
  if (!sales.length || new Set(sales.map((s) => s.id)).size !== sales.length)
    throw new Error('Choose distinct sales for greetings.');
  let pool: number[] = [];
  return sales.map((sale) => {
    if (!pool.length) {
      pool = GREETING_LIBRARY.map((_, index) => index);
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j]!, pool[i]!];
      }
    }
    const [message, quote] = GREETING_LIBRARY[pool.pop()!]!;
    return {
      id: sale.id,
      number: sale.number,
      customerName: sale.customerName?.trim() || 'Customer',
      message,
      quote,
    };
  });
}
